import { jwtDecode } from 'jwt-decode';

const safeDecode = (token) => {
  if (!token) return null;
  try {
    return jwtDecode(token);
  } catch (_) {
    return null;
  }
};

const isTokenValid = (token) => {
  const content = safeDecode(token);
  if (!content?.exp) return false;
  const expiryTime = content.exp * 1000;
  return expiryTime > Date.now();
};

const readProfile = () => {
  try {
    const raw = localStorage.getItem('profile');
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (_) {
    localStorage.removeItem('profile');
    return null;
  }
};

export { isTokenValid, readProfile };
